export default "__VITE_ASSET__541478a2__"